import { ReactNode } from 'react'
import { Helmet } from 'react-helmet-async'

import { faHome } from '@fortawesome/pro-light-svg-icons'

import { Box } from '@domain-group/suit-theme'

import PageHeader from '@components/PageHeader'

interface PageLayoutProps {
  activeTabBarItemKey: 'dashboard',
  children: ReactNode,
}

const PageLayout = (props: PageLayoutProps) => {
  const { activeTabBarItemKey, children } = props

  return (
    <>
      <Helmet>
        <title>Overview | Realhub</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey={activeTabBarItemKey}
        tabBarItems={[
          {
            href: '#/',
            icon: faHome,
            key: 'dashboard',
            title: 'Dashboard',
          },
        ]}
        title="Help Desk"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        {children}
      </Box>
    </>
  )
}

export default PageLayout
